/**
 * Subscription feature key constants.
 * Keys must match the `feature.key` values returned by GET /billing/subscriptions.
 */

export const SUBSCRIPTION_FEATURES = {
  WHATSAPP_AGENT: "finitless_whatsapp_ordering_agent",
  WEBCHAT_AGENT: "finitless_webchat_ordering_agent",
  INTEGRATIONS_POS: "finitless_integrations_pos",
  INTEGRATIONS_SALES_CHANNELS: "finitless_integrations_sales_channels",
  INTEGRATIONS_DELIVERY_SERVICES: "finitless_integrations_delivery_services",
};

/**
 * These Finitless-specific gates must be resolved from GET /frontends/first_load.
 */
export const FIRST_LOAD_FEATURE_KEYS = new Set([
  SUBSCRIPTION_FEATURES.WHATSAPP_AGENT,
  SUBSCRIPTION_FEATURES.WEBCHAT_AGENT,
  SUBSCRIPTION_FEATURES.INTEGRATIONS_POS,
  SUBSCRIPTION_FEATURES.INTEGRATIONS_SALES_CHANNELS,
  SUBSCRIPTION_FEATURES.INTEGRATIONS_DELIVERY_SERVICES,
]);

export const isFirstLoadFeatureKey = (featureKey) =>
  FIRST_LOAD_FEATURE_KEYS.has(featureKey);

/**
 * Maps AI Agent provider names (from useAvailableProviders) to subscription feature keys.
 * Providers not in this map are shown unconditionally.
 */
export const PROVIDER_FEATURE_MAP = {
  whatsapp: SUBSCRIPTION_FEATURES.WHATSAPP_AGENT,
  finitless: SUBSCRIPTION_FEATURES.WEBCHAT_AGENT,
};
